export default __webpack_public_path__ + "static/area-with-negative-values-d3d6407e699e11af1b21522c4650c8d2.png";